const TRANSLATABLE_ATTRIBUTES = ['placeholder', 'title', 'aria-label'];
const NON_TRANSLATABLE_TAGS = ['SCRIPT', 'STYLE', 'NOSCRIPT', 'SELECT', 'OPTION', 'DATALIST'];

const setOriginalAttribute = (element, attribute, value) => {
  element.setAttribute(`data-i18n-${attribute}`, value);
};

const getOriginalAttribute = (element, attribute) => {
  return element.getAttribute(`data-i18n-${attribute}`) || element.getAttribute(attribute);
};

const translateTextNode = (textNode, translate) => {
  const currentText = textNode.textContent ?? '';
  const hasExternalTextUpdate =
    textNode.__i18nOriginalText !== undefined &&
    textNode.__i18nLastAppliedText !== undefined &&
    currentText !== textNode.__i18nLastAppliedText;

  if (textNode.__i18nOriginalText === undefined || hasExternalTextUpdate) {
    textNode.__i18nOriginalText = currentText;
  }

  const originalText = textNode.__i18nOriginalText;
  const trimmedOriginalText = originalText.trim();
  if (!trimmedOriginalText) {
    return;
  }

  const translatedText = translate(trimmedOriginalText);
  const leadingWhitespace = originalText.match(/^\s*/)?.[0] || '';
  const trailingWhitespace = originalText.match(/\s*$/)?.[0] || '';
  const nextText = translatedText !== trimmedOriginalText
    ? `${leadingWhitespace}${translatedText}${trailingWhitespace}`
    : originalText;

  if (textNode.textContent !== nextText) {
    textNode.textContent = nextText;
  }

  textNode.__i18nLastAppliedText = nextText;
};

const translateElementText = (element, translate) => {
  Array.from(element.childNodes).forEach((node) => {
    if (node.nodeType === Node.TEXT_NODE) {
      translateTextNode(node, translate);
    }
  });
};

const translateElementAttributes = (element, translate) => {
  TRANSLATABLE_ATTRIBUTES.forEach((attribute) => {
    const currentValue = element.getAttribute(attribute);
    if (!currentValue) {
      return;
    }

    if (!element.hasAttribute(`data-i18n-${attribute}`)) {
      setOriginalAttribute(element, attribute, currentValue);
    }

    const originalValue = getOriginalAttribute(element, attribute);
    const translatedValue = translate(originalValue);
    if (element.getAttribute(attribute) !== translatedValue) {
      element.setAttribute(attribute, translatedValue);
    }
  });
};

export const applyDomTranslations = (root, translate) => {
  if (!root) {
    return;
  }

  const elements = root.querySelectorAll('*');
  elements.forEach((element) => {
    if (NON_TRANSLATABLE_TAGS.includes(element.tagName)) {
      return;
    }

    if (element.getAttribute('data-i18n-skip') === 'true') {
      return;
    }

    translateElementText(element, translate);
    translateElementAttributes(element, translate);
  });
};
